import { api } from "../services/api.service";
import { UserProfile } from "../store/types/user.types";

export const userApi = {
  getUserProfile: async (): Promise<UserProfile> => {
    return api.get<UserProfile>("/user");
  },
};
